import styles from "./ReportReviewButton.scss";
import PropTypes from "prop-types";
import React from "react";
import { useReportReviews } from "../reportReviews/useReportReviews";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

const ReportReviewButton = ({
  reviewId,
  onReportSuccess,
  isReported,
  reviewIsInModal,
}) => {
  const { handleReportButtonClick, disabled, reportReviewText } =
    useReportReviews(reviewId, onReportSuccess, reviewIsInModal);
  const { getTranslation } = useRuntimeConstants();
  return (
    <div className={styles.reportReviewButtonContainer}>
      <button
        disabled={disabled || isReported}
        className={styles.reportReviewButton}
        onClick={handleReportButtonClick}
        data-testid="reportReviewButton"
      >
        {isReported
          ? getTranslation("pdp_ratings_reviews_reported_review")
          : reportReviewText}
      </button>
    </div>
  );
};

ReportReviewButton.propTypes = {
  reviewId: PropTypes.string.isRequired,
  isReported: PropTypes.bool.isRequired,
  onReportSuccess: PropTypes.func,
  reviewIsInModal: PropTypes.string,
};

export default ReportReviewButton;
